module.exports = __webpack_public_path__ + "static/forwarder-5d55936c5f2cb4f62abbffa70898a627.png";